/* unplugin-vue-components disabled */import { render } from "./sxgcmap.vue?vue&type=template&id=2542e078&scoped=true"
import script from "./sxgcmap.vue?vue&type=script&lang=js"
export * from "./sxgcmap.vue?vue&type=script&lang=js"

import "./sxgcmap.vue?vue&type=style&index=0&id=2542e078&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2542e078"]])

export default __exports__